import { FC } from 'react'

import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { AdCampaignStrategyEnum } from 'src/Redux/ad-campaignApi'

import { NoAuthPageLayout } from '../../Components/NoAuthPageLayout'
import { HelmetTitle } from '../../Components/HelmetTitle'
import { CreateCampaignBreadcrumbsNoAuthAds } from '../../Components/CreateCampaignBreadcrumbsNoAuthAds'

import { useMetaAdsRegisterPage } from './useMetaAdsRegisterPage'
import { useMetaAdsResource } from './useMetaAdsResource'
import { MetaAdsRegisterContent } from './Components/MetaAdsRegisterContent'

const Container = styled.div`
  display: flex;
  max-width: 960px;
  margin: 0 auto;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    gap: 40px;
  }
`

export const ArtistRegisterPageMetaAds: FC = () => {
  const {
    resource,
    loading: isResourceLoading,
    strategy,
  } = useMetaAdsResource()

  const resourceData = resource
    ? {
        name: resource.name,
        ownerName: resource.artistName || '',
        coverUrl: resource.trackCoverUrl || '',
        resourceSpotifyUrl: resource.resourceSpotifyUrl || '',
        ownerSpotifyUrl: resource.ownerSpotifyUrl || '',
      }
    : null

  const {
    handleSubmit,
    onGoogleClick,
    isEmailExist,
    clearEmailExist,
    loading: isRegisterLoading,
    onStartFillingForm,
  } = useMetaAdsRegisterPage(resourceData)

  const isPlaylist = strategy === AdCampaignStrategyEnum.PLAYLIST

  return (
    <NoAuthPageLayout>
      <HelmetTitle />

      <Container>
        <CreateCampaignBreadcrumbsNoAuthAds />
        <MetaAdsRegisterContent
          isEmailExist={isEmailExist}
          clearEmailExist={clearEmailExist}
          isRegisterLoading={isRegisterLoading}
          onSubmitRegisterForm={handleSubmit}
          onGoogleClick={onGoogleClick}
          onStartFillingForm={onStartFillingForm}
          isResourceDataLoading={isResourceLoading}
          resourceCoverUrl={resource?.trackCoverUrl}
          resourceName={resource?.name}
          ownerName={resource?.artistName}
          duration={resource?.trackDuration}
          trackPreviewUrl={isPlaylist ? void 0 : resource?.previewUrl}
          isPlaylist={isPlaylist}
        />
      </Container>
    </NoAuthPageLayout>
  )
}
